import { ROUTES } from "@routing/routes";
import { Button } from "@common/index";
import { ComponentColor } from "@common/types";
import { VALUE_PROPS_SECTION_ID } from "./ValueProps";

export const HomePageHero = () => {
    const handleLearnMore = () => {
        document
            .getElementById(VALUE_PROPS_SECTION_ID)
            ?.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <section className="bg-base-100">
            <div className="max-w-6xl mx-auto px-4 py-12 lg:py-20 grid items-center gap-10 lg:grid-cols-2">
                <div className="text-primary">
                    <h1 className="text-3xl lg:text-5xl font-bold leading-tight">
                        Your source for premium Cannabis, CBD, Kratom, Vapes and
                        more!
                    </h1>
                    <p className="mt-4 text-base lg:text-lg">
                        Streamline Your Supply Chain: Order, Restock, and Grow
                        Faster
                    </p>
                    <div className="mt-8 flex flex-wrap gap-3">
                        <Button
                            to={ROUTES.APPLY}
                            color={ComponentColor.Warning}
                            className="text-base text-neutral font-bold normal-case"
                        >
                            Apply Now
                        </Button>
                        <Button
                            onClick={handleLearnMore}
                            color={ComponentColor.Primary}
                            outline
                            className="text-base font-bold normal-case"
                        >
                            Learn More
                        </Button>
                    </div>
                </div>
                {/* TODO(content): real marketing photo */}
                <img
                    src="/businesspeople.jpg"
                    alt="NARA warehouse shelves stocked with product"
                    className="rounded-2xl shadow-lg w-full object-cover max-h-96"
                />
            </div>
        </section>
    );
};
